import { useState, useEffect, useCallback } from 'react';
import { API_BASE } from '../utils/apiEndpoints';

export function useSubscriptionStatus() {
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/subscription/status`, {
        credentials: 'include'
      });
      const data = await res.json().catch(() => ({ hasActiveSubscription: false }));
      setHasActiveSubscription(!!data.hasActiveSubscription);
    } catch {
      setHasActiveSubscription(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { hasActiveSubscription, loading, refetch: fetchStatus };
}
